const SquareSenegal = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 16">
      <g clipPath="url(#a)">
        <g clipPath="url(#b)">
          <rect width="22" height="16" fill="#FFDA2C" rx="2" />
          <path fill="#249F58" fillRule="evenodd" d="M0 0H7V16H0V0Z" clipRule="evenodd" />
          <path fill="#F93939" fillRule="evenodd" d="M15 0H22V16H15V0Z" clipRule="evenodd" />
          <path
            fill="#249F58"
            fillRule="evenodd"
            d="M11 9.3335L9.46003 10.158L9.75336 8.4119L8.50879 7.17456L10.23 6.92176L11 5.3335L11.77 6.92283L13.4913 7.17563L12.2446 8.41296L12.5379 10.158"
            clipRule="evenodd"
          />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="white" d="M0 0H22V16H0z" />
        </clipPath>
        <clipPath id="b">
          <rect width="22" height="16" fill="white" rx="2" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SquareSenegal;
